import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black/50 border-t border-ewss-cyan/20 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_automation-hub-228/artifacts/auocukq6_logo.png" 
                  alt="EWSS Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <div className="text-white font-bold text-lg">
                  EWSS <span className="text-ewss-cyan">Automation</span>
                </div>
                <div className="text-ewss-cyan text-xs">30 Years of Logic</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Leading provider of building and industrial automation solutions with three decades of expertise.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center text-gray-400">
                <MapPin size={16} className="mr-2 text-ewss-cyan" />
                South Africa
              </div>
              <div className="flex items-center text-gray-400">
                <Phone size={16} className="mr-2 text-ewss-cyan" />
                <a href="tel:+27825588139" className="hover:text-ewss-cyan transition-colors">
                  +27 082 558 8139
                </a>
              </div>
              <div className="flex items-center text-gray-400">
                <Mail size={16} className="mr-2 text-ewss-cyan" />
                <a href="mailto:info@ewss.co.za" className="hover:text-ewss-cyan transition-colors">
                  info@ewss.co.za
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-400 hover:text-ewss-cyan transition-colors">About Us</Link></li>
              <li><Link to="/solutions" className="text-gray-400 hover:text-ewss-cyan transition-colors">Solutions</Link></li>
              <li><Link to="/brands" className="text-gray-400 hover:text-ewss-cyan transition-colors">Brands</Link></li>
              <li><Link to="/resources" className="text-gray-400 hover:text-ewss-cyan transition-colors">Resources</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-ewss-cyan transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Brands</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/brands/haiwell" className="text-gray-400 hover:text-ewss-cyan transition-colors">Haiwell</Link></li>
              <li><Link to="/brands/supmea" className="text-gray-400 hover:text-ewss-red transition-colors">Supmea</Link></li>
              <li><Link to="/brands/savch" className="text-gray-400 hover:text-ewss-orange transition-colors">Savch</Link></li>
              <li><Link to="/brands/yotta-control" className="text-gray-400 hover:text-ewss-green transition-colors">Yotta Control</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-ewss-cyan/20 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} EWSS Automation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;